export enum AssessmentTypes {
  ACCREDITATION = "ACCREDITATION",
  APPLICATION = "APPLICATION",
}
